package one.healthium.profile.ui.models

import androidx.compose.runtime.Immutable
import one.healthium.loco.LString

@Immutable
internal data class CaloriesHistoryUiModel(
    val value: Float,
    val date: LString,
)
